export const environment = {
  production: "true",
  mode: "production",
  kpiServiceApi: "https://mosaic.schoolzilla.com",
  szAppHostname: "https://app.schoolzilla.com",
  apiVersion: "v2",
  rollbarAccessToken: "ebfc0404891442aebf0d9d4f49a1e0e3",
  rlChatFile: "https://chatfile.renlearn.com/whoson_realtime.js",
  launchDarklyClientSideId: "630e47d58fac91126db1c3ed",
};
